import { render, staticRenderFns } from "./SSelectProducerRc.vue?vue&type=template&id=23bf3014"
import script from "./SSelectProducerRc.vue?vue&type=script&lang=js"
export * from "./SSelectProducerRc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports